// ============================================================================
// BackablePage.jsx — korniza E PËRBASHKËT e faqeve TË JASHTME të app-it
// (/join, /start, /invite). Këto janë dokumente më vete (ngarkim i plotë
// faqeje), pra sistemi i "back"-ut i App.jsx nuk i mbulon fare. Deri tani
// secila kishte kopjen e vet të kartelës, ndaj çdo rregullim duhej bërë tri
// herë — dhe mbetej gjithmonë ndonjë vend i harruar. Tani ka NJË zbatim:
//
//   • butoni "← Kthehu" (i pranishëm në ÇDO gjendje të faqes),
//   • SWIPE djathtas kudo në faqe, me tërheqje vizuale si te modalet e app-it,
//   • tasti Escape,
//   • kthim te DRITARJA ku ishe (jo te ballina) — shih `pef_return` te App.jsx.
//
// PSE SWIPE-I S'PUNONTE MË PARË: versioni i mëparshëm i shpërfillte gjestet që
// nisnin te skaji i majtë (≤28px) për të shmangur "back-un e dyfishtë" — por
// pikërisht aty e nis gjestin çdo përdorues, ndaj praktikisht nuk aktivizohej
// kurrë. Zgjidhja e saktë: e zotërojmë vetë gjestin — `touch-action: pan-y`
// plus `preventDefault()` në një dëgjues JO-pasiv e ndalojnë gjestin e vetë
// sistemit, kështu s'ka dyfishim dhe swipe-i punon nga kudo, edhe nga skaji.
// ============================================================================

import React, { useEffect, useRef, useState } from "react";

let _backGuardAt = 0;

export function goBackFromPage() {
  // Mbrojtje kundër dy thirrjeve njëherësh (p.sh. buton + gjest).
  const now = Date.now();
  if (now - _backGuardAt < 900) return;
  _backGuardAt = now;
  // 1) Kthim i saktë te vendi nga erdhëm, me dritaren e rihapur (App.jsx →
  //    leaveToPage ruan `pef_return`; App.jsx në nisje lexon `pef_reopen`).
  try {
    const raw = sessionStorage.getItem("pef_return");
    if (raw) {
      const ret = JSON.parse(raw);
      sessionStorage.removeItem("pef_return");
      if (ret && ret.reopen) sessionStorage.setItem("pef_reopen", ret.reopen);
      window.location.href = (ret && ret.path) || "/";
      return;
    }
  } catch (_e) { /* private mode → vazhdo me historinë */ }
  // 2) Pa marker (link i hapur direkt, p.sh. nga email-i): historia, pastaj "/".
  try {
    if (window.history.length > 1) { window.history.back(); return; }
  } catch (_e) { /* asgjë */ }
  window.location.href = "/";
}

export function BackableCard({ title, children, width = 420 }) {
  const [dragX, setDragX] = useState(0);
  const start = useRef(null);
  const rootRef = useRef(null);

  // Dëgjues JO-pasiv: vetëm kështu mund të bëhet preventDefault() dhe t'i hiqet
  // gjesti sistemit. React-i i lidh touchmove-t si pasive, ndaj lidhet me dorë.
  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const onMove = (e) => {
      if (!start.current || e.touches.length !== 1) return;
      const dx = e.touches[0].clientX - start.current.x;
      const dy = e.touches[0].clientY - start.current.y;
      if (Math.abs(dy) > Math.abs(dx)) return; // lëvizje vertikale = scroll normal
      if (dx > 0) {
        if (e.cancelable) e.preventDefault();
        setDragX(dx);
      }
    };
    el.addEventListener("touchmove", onMove, { passive: false });
    return () => el.removeEventListener("touchmove", onMove);
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") goBackFromPage(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const endGesture = () => {
    const d = dragX;
    start.current = null;
    setDragX(0);
    if (d > 70) goBackFromPage();
  };

  return (
    <div
      ref={rootRef}
      onTouchStart={(e) => { start.current = { x: e.touches[0].clientX, y: e.touches[0].clientY }; }}
      onTouchEnd={endGesture}
      onTouchCancel={() => { start.current = null; setDragX(0); }}
      style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        minHeight: "100vh", fontFamily: "system-ui, sans-serif", background: "#f9fafb",
        touchAction: "pan-y", overscrollBehaviorX: "contain",
      }}
    >
      <div
        style={{
          width: `min(${width}px, calc(100vw - 24px))`, background: "#fff", borderRadius: 12,
          padding: 32, boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          transform: dragX ? `translateX(${dragX}px)` : undefined,
          opacity: dragX ? Math.max(0.4, 1 - dragX / 300) : 1,
          transition: dragX ? "none" : "transform .22s ease, opacity .22s ease",
        }}
      >
        <button
          onClick={goBackFromPage}
          /* 4 shtator 2026 — zona e prekjes ishte sa vetë teksti (~18px i lartë).
             Tani 44px e lartë, me `margin` negativ që pamja të mos lëvizë. */
          style={{ display: "flex", alignItems: "center", gap: 6, background: "transparent", border: "none", padding: "0 12px", margin: "-13px -12px 1px", minHeight: 44, minWidth: 44, color: "#6b7280", fontSize: 13.5, cursor: "pointer", fontFamily: "inherit" }}
        >
          ← Kthehu
        </button>
        <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 20 }}>{title}</h1>
        <div style={{ fontSize: 14, color: "#333" }}>{children}</div>
      </div>
    </div>
  );
}
